import { render, staticRenderFns } from "./tnc-pt.vue?vue&type=template&id=e6daeb4e&scoped=true"
import script from "./tnc-pt.vue?vue&type=script&lang=js"
export * from "./tnc-pt.vue?vue&type=script&lang=js"
import style0 from "./tnc-pt.vue?vue&type=style&index=0&id=e6daeb4e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6daeb4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6daeb4e')) {
      api.createRecord('e6daeb4e', component.options)
    } else {
      api.reload('e6daeb4e', component.options)
    }
    module.hot.accept("./tnc-pt.vue?vue&type=template&id=e6daeb4e&scoped=true", function () {
      api.rerender('e6daeb4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/tnc/tnc-pt.vue"
export default component.exports